import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { IMAGE_TYPE } from 'src/app/core/constants/common';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { ChooseImageModalComponent } from '../components/choose-image/choose-image.component';
import { FaceDetectionComponent } from '../components/face-detection/face-detection.component';

@Component({
  selector: 'app-popup-face-math-ekyc',
  templateUrl: './popup-face-math-ekyc.component.html',
  styleUrls: ['./popup-face-math-ekyc.component.scss']
})
export class PopupFaceMathEkycComponent implements OnInit {
  safeMessage: SafeHtml;
  documentExpanded = true;
  portraitExpanded = false;
  fileCCCDMT = {
    fileName: '',
    imageBase64: '',
    type: 80,
    filePath: ''
  }
  fileCCCDMS = {
    fileName: '',
    imageBase64: '',
    type: 81,
    filePath: ''
  }
  fileCD = {
    fileName: '',
    imageBase64: '',
    type: 85,
    filePath: ''
  }
  readonly IMAGE_TYPE = IMAGE_TYPE;
  isRetryCCCDMT: boolean = false;
  isRetryCCCDMS: boolean = false;
  isRetryCD: boolean = false;
  dataCheckVneid: any;
  certificateNo: string = '';
  nonce: string = '';
  sdkLicence: string = '';
  encryptFaceImage: string = '';
  @BlockUI() blockUI: NgBlockUI;

  

  constructor(
    public dialogRef: MatDialogRef<PopupFaceMathEkycComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentMohaService: DocumentMohaService,
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {
    dialogRef.disableClose = false;
    this.dataCheckVneid = data.dataCheckVneid;
    this.nonce = data.nonce;
    this.sdkLicence = data.sdkLicence;
    this.certificateNo = this.dataCheckVneid.certificateNoCCCD;
  }

  ngOnInit(): void {}

  /** Đóng dialog, trả về false (Hủy bỏ / nút X) */
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  toggle(section: 'document' | 'portrait'): void {
    if (section === 'document') {
      this.documentExpanded = !this.documentExpanded;
      return;
    }
    this.portraitExpanded = !this.portraitExpanded;
  }
  onChooseImage(type: number) {
    if (type === this.IMAGE_TYPE.FILE_FACE) {
      const dialogEkyc = this.dialog.open(FaceDetectionComponent, {
        width: '800px',
        data: {
          nonce: this.nonce,
          sdkLicence: this.sdkLicence
        }
      });
      dialogEkyc.afterClosed().subscribe(res => {
        if (res) {
          this.fileCD.fileName = res.name;
          this.fileCD.imageBase64 = res.imageBase64;
          this.isRetryCD = false;
          this.encryptFaceImage = res.faceImages;
          this.documentMohaService.encryptFaceImage.next(this.encryptFaceImage);
          this.documentMohaService.uploadFileV2(res).pipe(
                  timeout(60000),
                  catchError(err => {
                    this.isRetryCD = true;
                    return throwError(() => err);
                  })
                ).subscribe((response:any) => {
            if (response.success) {
              this.fileCD.filePath = response.data;
              // this.contractService.setFileCD(this.fileCD);
            } else {
              this.isRetryCD = true;
            }
          })
          }
      })
    } else {
      const dialogEkyc = this.dialog.open(ChooseImageModalComponent, {
        width: '350px',
      });
      dialogEkyc.afterClosed().subscribe(res => {
        if (res) {  
          switch (type) {
            case this.IMAGE_TYPE.FILE_CMND_FRONT:
              this.fileCCCDMT.fileName = res.name;
              this.fileCCCDMT.imageBase64 = res.imageBase64;
              this.isRetryCCCDMT = false;
              this.documentMohaService.uploadFileV2(res).pipe(
                  timeout(60000),
                  catchError(err => {
                    this.isRetryCCCDMT = true;
                    return throwError(() => err);
                  })
                ).subscribe((response:any) => {
                if (response.success) {
                  this.fileCCCDMT.filePath = response.data;
                  // this.documentMohaService.setFileCCCDMT(this.fileCCCDMT);
                } else {
                  this.isRetryCCCDMT = true;
                }
              })
            break;
            case this.IMAGE_TYPE.FILE_CMND_BACK:
              this.fileCCCDMS.fileName = res.name;
              this.fileCCCDMS.imageBase64 = res.imageBase64;
              this.isRetryCCCDMS = false;
              this.documentMohaService.uploadFileV2(res).pipe(
                  timeout(60000),
                  catchError(err => {
                    this.isRetryCCCDMS = true;
                    return throwError(() => err);
                  })
                ).subscribe((response:any) => {
                if (response.success) {
                  this.fileCCCDMS.filePath = response.data;
                  // this.documentMohaService.setFileCCCDMS(this.fileCCCDMS);
                } else {
                  this.isRetryCCCDMS = true;
                }
              })
            break;
          }
        } 
      })
    }
  }
  clearImageUpload(type: number) {
    switch (type) {
      case this.IMAGE_TYPE.FILE_CMND_FRONT:
        this.fileCCCDMT.fileName = '';
        this.fileCCCDMT.filePath = '';
        this.fileCCCDMT.imageBase64 = '';
        break;
      case this.IMAGE_TYPE.FILE_CMND_BACK:
        this.fileCCCDMS.fileName = '';
        this.fileCCCDMS.filePath = '';
        this.fileCCCDMS.imageBase64 = '';
        break;
      default:
        this.fileCD.fileName = '';
        this.fileCD.filePath = '';
        this.fileCD.imageBase64 = '';
        break;
    }
  }

  verifyEkyc() {
    this.blockUI.start();
    const body = {
      typeImage: 8,
      images: [
        {
          ...this.fileCCCDMT
        },
        {
          ...this.fileCCCDMS
        },
        {
          ...this.fileCD
        },
      ],
      certificateNo: this.certificateNo
    }
    this.documentMohaService.validateFaceMatch(body).pipe(finalize(() => {
      this.blockUI.stop();
    })).subscribe(res => {
      if (res.success) {
        this.dialogRef.close(true);
      } else {
        this.toastr.error(res.message);
      }
    })
  }
}